import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ProjectFormData {
  name: string;
  folder: string;
  numberOfCameras: number;
  beginDate?: string;
}

@Component({
  selector: 'app-project-form-dialog',
  templateUrl: './project-form-dialog.component.html',
  styleUrls: ['./project-form-dialog.component.css']
})
export class ProjectFormDialogComponent {
  project: ProjectFormData = { name: '', folder: '', numberOfCameras: 1 };

  constructor(
    public dialogRef: MatDialogRef<ProjectFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onSave(): void {
    // Here you can call a service to create the project.
    // For now, we simply close the dialog and return the form data.
    this.dialogRef.close(this.project);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}